<template lang="pug">
  .component-reporting-list.row.column
    reporting-list-form(@filterReportings="setSearch")
    base-list(:component="component", :dataLoader="dataLoader", :search="search")
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'

  import ReportingListForm from "../../components/structure/ui/filters/ReportingListForm";
  import BaseList from "./BaseList";

  export default {
    name: "ReportingList",
    components: {
      ReportingListForm,
      BaseList
    },
    data: function () {
      return {
        component: require('src/components/backoffice/Reporting'),
        search: null
      }
    },
    methods: {
      dataLoader(callback, page, resultsPerPage, search) {
        KeplerBackofficeSdk.reportings.list(page, resultsPerPage, search).all((data) => {
          callback(data)
        })
      },
      setSearch(search) {
        this.search = search
      }
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// ReportingList.vue?495c92c8